import { BaseStorage } from '../base-storage';
import { NOT_FOUND, SERVER_ERROR } from '../utils/constants';
function getCookieValue(name) {
    if (typeof document === 'undefined') {
        return '';
    }
    return (document.cookie.match(`${name}=([^;]*)`) || ['']).pop() ?? '';
}
export function getUserId() {
    const wixClient = getCookieValue('wixClient').split('|');
    return wixClient[6] || getCookieValue('_wixCIDX');
}
export class WixStorageStrategy extends BaseStorage {
    constructor({ httpClient }) {
        super();
        this.httpClient = httpClient;
    }
    extendScope(scope) {
        return {
            userId: getUserId(),
            ...(typeof scope === 'string' ? { siteId: scope } : scope),
        };
    }
    setItem(key, value, options) {
        const payload = {
            nameSpace: options.namespace,
            key,
            blob: value,
        };
        if (typeof options.scope === 'object' && options.scope.siteId) {
            payload.siteId = options.scope.siteId;
        }
        if (options.expiration) {
            payload.TTLInDays = Math.ceil(options.expiration / (60 * 60 * 24));
        }
        return this.httpClient
            .post('/_api/wix-user-preferences-webapp/set', payload)
            .then(() => undefined)
            .catch((e) => {
            console.error(e);
            throw SERVER_ERROR;
        });
    }
    removeItem(key, options) {
        const payload = {
            nameSpace: options.namespace,
            key,
        };
        if (typeof options.scope === 'object' && options.scope.siteId) {
            payload.siteId = options.scope.siteId;
        }
        return this.httpClient
            .post('/_api/wix-user-preferences-webapp/delete', payload)
            .then(() => undefined)
            .catch(() => {
            throw SERVER_ERROR;
        });
    }
    getItem(key, options) {
        const siteId = typeof options.scope === 'object' ? options.scope.siteId : undefined;
        const path = siteId ? 'getVolatilePrefForSite' : 'getVolatilePrefForKey';
        const url = [
            '/_api/wix-user-preferences-webapp',
            path,
            options.namespace,
            siteId,
            key,
        ]
            .filter((x) => x)
            .join('/');
        return this.httpClient
            .get(url)
            .then((res) => res.data[key])
            .catch((err) => {
            throw err?.response?.status === 404 ? NOT_FOUND : SERVER_ERROR;
        });
    }
    getAllItems(options) {
        const siteId = typeof options.scope === 'object' ? options.scope.siteId : undefined;
        const path = siteId ? 'getVolatilePrefsForSite' : 'getVolatilePrefs';
        const url = [
            '/_api/wix-user-preferences-webapp',
            path,
            options.namespace,
            siteId,
        ]
            .filter((x) => x)
            .join('/');
        return this.httpClient
            .get(url)
            .then((res) => res.data)
            .catch(() => {
            throw SERVER_ERROR;
        });
    }
}
//# sourceMappingURL=wix-storage.js.map